import { DSButton, DSFlex, DSIcon, DSText } from '@zoe/ds-web'
import type { PressEvent } from 'react-aria-components'

type NavAccountButtonProps = {
  label: string
  icon?: React.ComponentProps<typeof DSIcon>['name']
  onPress: (event: PressEvent) => void
  testId?: string
}

// Accessible replacement for NavButton, scoped to the new nav's account controls
// (Login / Account / Logout). Renders a single interactive DSButton (a real
// react-aria button) with a working onPress — no overlay anchor, so there is one
// tab stop and keyboard activation works. The legacy NavButton is intentionally
// left in place for the page-level header CTAs.
export const NavAccountButton = ({ label, icon, onPress, testId }: NavAccountButtonProps) => (
  <DSButton
    variant="secondary"
    colorScheme="default"
    size="small"
    width="auto"
    onPress={onPress}
    style={{ textWrap: 'nowrap' }}
    testId={testId}
  >
    <DSFlex direction="row" alignItems="center" gap={8}>
      {icon && <DSIcon name={icon} size={16} aria-hidden="true" />}
      <DSText
        as="span"
        variant="fluid-paragraph-200"
        weight="semiBold"
        color="primary"
        breakAt={{ breakPoint: 'm', variant: 'fluid-label-100' }}
      >
        {label}
      </DSText>
    </DSFlex>
  </DSButton>
)
